import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { io } from "socket.io-client";
import Styles from "../../styles/preview/welcome.module.scss";
import Img_logo from "../../assets/auth/LOGO.svg";
import Start_logo from "../../assets/dashboard/start.jpeg";
import { adminRoutes } from "../../routers/AdminRouters";
import { ApiEndpoints, LocalStorageKeys } from "../../core";
import { useDispatch, useSelector } from "react-redux";
import { getScheduleGym } from "../../services";
import { updateIsPlayingState } from "../../redux";

const IdleScreen = () => {
  const { gymSchedule } = useSelector((state) => state.schedule);
  const [socket, setSocket] = useState(null);
  const [currentDate] = useState(new Date());
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const todaySchedule = gymSchedule?.find((schedule) => {
    const scheduleDate = new Date(schedule.date);
    return scheduleDate.toDateString() === currentDate.toDateString();
  });

  useEffect(() => {
    getScheduleGym();
  }, []);

  useEffect(() => {
    const gymToken = localStorage.getItem(LocalStorageKeys.gymToken);

    if (gymToken) {
      const socketInit = io(ApiEndpoints.serverURL, {
        reconnectionDelayMax: 10000,

        auth: {
          token: `Bearer ${gymToken}`,
        },
      });
      setSocket(socketInit);
    } else {
      console.error("Token not found in local storage");
    }
  }, []);

  const sessionId = todaySchedule?._id;
  const handleStart = () => {
    if (socket) {
      socket.emit("preview_control_status", {
        sessionId,
        status: "play",
      });
      dispatch(updateIsPlayingState({ sessionId, isPlaying: true }));

      navigate(adminRoutes.previewScreen);
    } else {
      console.error("Socket not initialized yet.");
    }
  };
  useEffect(() => {
    if (!socket) return;

    const handlePreviewProgressStatus = (data) => {
      const { status } = data;
      if (status === "play") {
        navigate(adminRoutes.previewScreen);
        dispatch(updateIsPlayingState({ sessionId, isPlaying: true }));
      }
    };

    socket.on("preview_control_status", handlePreviewProgressStatus);

    return () => {
      socket.off("preview_control_status", handlePreviewProgressStatus);
    };
  }, [socket, navigate]);

  return (
    <div className={Styles.welcome_container}>
      <div className={Styles.logo}>
        <div className={Styles.flexdivider_2_logo}>
          <img src={Img_logo} alt="admin_dash_logo" />
        </div>
      </div>

      <div className={Styles.start_box} onClick={handleStart}>
        <p className={Styles.start}>START</p>
      </div>
    </div>
  );
};

export default IdleScreen;
